<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="p-3">
        <app-header class="mb-3" title="经纪人修改的MMSI"/>
        <b-form-checkbox class="mb-2" v-model="hideReviewed">不显示已确认的MMSI修改记录</b-form-checkbox>
        <div v-if="loading" class="text-center w-100">
            <b-spinner label="Spinner"></b-spinner>
        </div>
        <template v-else>
            <div v-if="!items.length" class="text-center p-2 w-100">没有符合条件的MMSI修改记录</div>
            <table v-else class="table table-bordered table-striped text-center">
                <tr>
                    <th>序号</th>
                    <th>修改人</th>
                    <th>修改时间</th>
                    <th>船名</th>
                    <th>MMSI</th>
                    <th>图片</th>
                    <th>操作</th>
                </tr>
                <tr v-for="(item, index) in items" :key="item.id">
                    <td>{{index + 1}}</td>
                    <td>{{item.userName}}</td>
                    <td>{{item.createTime | momentFormat}}</td>
                    <td>
                        <a v-if="item.seniorHash" class="anchor" target="_blank"
                           :href="'/voyage.html?hash=' + item.seniorHash + '&origin=blank'">
                            {{item.vessel}}
                        </a>
                        <span v-else>{{item.vessel}}</span>
                    </td>
                    <td>{{item.mmsi}}</td>
                    <td><a class="anchor" :href="item.photoUrl" target="_blank">查看图片</a></td>
                    <td>
                        <span v-if="item.reviewFlag">已确认</span>
                        <span v-else class="anchor" @click="confirm(item.id)">确认</span>
                    </td>
                </tr>
            </table>
        </template>
    </div>
</template>

<script>
import AppHeader from "../components/AppHeader";
import VesselMmsi from "../services/vesselMmsi";
import * as MsgBox from "../utils/msgBox"

export default {
    name: "VesselMmsiReview",
    components: {AppHeader},
    data() {
        return {
            hideReviewed: true,
            items: [],
            loading: true,
            selectedId: 0,
        };
    },
    methods: {
        async load() {
            try {
                this.loading = true;
                this.items = await VesselMmsi.list(this.hideReviewed);
            } finally {
                this.loading = false;
            }
        },
        async confirm(id) {
            if (await MsgBox.confirm(this, "要确认此项修改吗？")) {
                await VesselMmsi.confirm(id);
                this.load();
            }
        },
    },
    watch: {
        hideReviewed(val) {
            this.load();
        }
    },
    created() {
        this.load();
    },
}
</script>

<style scoped>

</style>
